// extracted by mini-css-extract-plugin
export default {"buscador":"search_buscador__FNCMl"};